/**
 * Created by brunopoeta on 10/05/17.
 */

export default function ToolbarDirective() {

    return {
        controller: ['$filter', ToolbarController],
        controllerAs: 'ctrl',
        scope: {
            fullWidth: '=',
            toolbar: '='
        },
        replace: true,
        restrict: 'E',
        templateUrl: window.templateDirectory + '/assets/app/templates/toolbar.html'
    }

}

class ToolbarController {

    constructor($filter) {
        this.$filter = $filter;
        this.ready = true;
    }

    changeFilter(item, filter, callback) {
        filter.selected = item;

        console.log('selected', filter.selected);

        if (callback) {
            callback();
        }
    }

    getLabel(filter, filters) {
        let label = '';

        if (filter.sort && filter.selected) {
            const context = filter.sort.context;
            const items = filter.items;
            const parent = filters[filter.sort.parent];

            const sortedItems =
                this
                    .$filter('sort')(items, context, parent.selected.id);

            angular.forEach(sortedItems, (item) => {
                if(item.id === filter.selected.id) {
                    label = filter.selected.label || filter.selected.name || filter.selected.title;
                }
            });
        } else if (filter.selected) {
            label = filter.selected.label || filter.selected.name || filter.selected.title;
        }

        filter.selected = (label) ? filter.selected : null;

        return (label || filter.label);
    }
}
